import React from "react";
// Import styles


const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <img src="/assets/img/logo/header-logo10a.svg" alt="Loading..." className="loading-logo" />
    </div>
  );
};

export default LoadingScreen;
